import { createFileRoute, redirect } from '@tanstack/react-router';

import { StudioTransactionTablePage } from '~pages/payments/studio-transaction-table/index';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/payment/studio-transaction-table',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: StudioTransactionTablePage,
});
